var settings_101 = {
    search: {
        minPay: 0,
        maxPay: 30000
    }
};
